import realTime from "./realtime.png";
import optimization from "./routeOptimization.png";
import dataAnalytics from "./dataAnalytics.png";
import automation from "./automation.png";
import security from "./security.png";
import customerSupport from "./customerSupport.png";
import reporting from "./reporting.png";
import integration from "./integration.png";

export const services = [
    { id: 1, image: realTime, title: "Real-Time Tracking", description: "Monitor your shipments in real time with our advanced tracking technology." },
    { id: 2, image: optimization, title: "Optimized Routing", description: "Plan the most efficient routes to reduce costs and save time." },
    { id: 3, image: dataAnalytics, title: "Data Analytics", description: "Gain valuable insights into logistics operations with robust analytics." },
    { id: 4, image: automation, title: "Automation", description: "Streamline operations with AI-powered automation solutions." },
    { id: 5, image: security, title: "Security & Compliance", description: "Ensure safety and compliance with our secure logistics solutions." },
    { id: 6, image: customerSupport, title: "24/7 Customer Support", description: "Get round-the-clock assistance for all your logistics needs." },
    { id: 7, image: reporting, title: "Advanced Reporting", description: "Generate detailed reports to improve decision-making." },
    { id: 8, image: integration, title: "Seamless Integration", description: "Integrate with existing systems for smooth operations." },
];